import React from 'react';
import { useForm } from '../../hooks/useForm';

export const SearchModalForm = ({ onSubmit }) => {
    const [searchForm, handleInputChange, resetForm] = useForm({
        category: '',
        filter: ''
    });
    const { category, filter } = searchForm;

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit({ category, filter });
    };

    const handleReset = (event) => {
        event.preventDefault();
        onSubmit({ category: '', filter: '' });
        resetForm();
    };

    return (
        <form className="row" onSubmit={handleSubmit} onReset={handleReset}>
            <div className="col-12 col-md-8 mb-3">
                <div className="input-group">
                    <input
                        type="text"
                        name="filter"
                        className="form-control"
                        placeholder="Search by product"
                        value={filter}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        name="category"
                        className="form-control"
                        placeholder="Search by category"
                        value={category}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
            <div className="btn-group col-12 col-md-4 mb-3">
                <button type="reset" className="btn btn-outline-secondary">
                    <span className="fas fa-eraser fa-fw"></span>
                </button>
                <button type="submit" className="btn btn-outline-primary">
                    <span className="fas fa-search fa-fw"></span>
                </button>
            </div>
        </form>
    );
};
